import { Injectable } from '@angular/core';
import { DeviceOnboardingService } from './device-onboarding.service';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class OnboardingCheckService {

  constructor(
    private onboarding: DeviceOnboardingService,
    private router: Router
  ) {}
    currentStep: string | null = null;
  // check(): void {
  //   this.onboarding.checkPending().subscribe({
  //     next: (res: any) => {
  //       const step = res?.data?.step;
  //       this.currentStep = step;

  //       if (step === 'VEHICLE_CONNECT') {

  //         this.router.navigate(['/setup/vehicle-connection']);
  //         return;
  //       }
  //       if (step === 'PERSONALISE') {
  //         this.router.navigate(['/setup/vehicle-connection']);
  //         return;
  //       }
  //       if (step === 'NONE') {
  //         this.router.navigate(['/setup/device-setup']);
  //         return;
  //       }
  //     },
  //     error: (err) => {
  // if (err.status === 401) {
  //   this.router.navigate(['/login']);
  // } else {
  //   this.router.navigate(['/dashboard']); // fallback
  // }      }
  //   });
  // }
    getStep() {
    // 🔥 This calls the API
    return this.onboarding.checkPending();
  }
}
